export default __webpack_public_path__ + "static/media/VideoThumbnail1.fea6ad44.svg";